module.exports = "<div id=\"wrapper\">\r\n  <bw-index-side></bw-index-side>\r\n  <div id=\"page-wrapper\" class=\"gray-bg\">\r\n    <bw-index-top></bw-index-top>\r\n    <bw-index-heading></bw-index-heading>\r\n    <div class=\"wrapper wrapper-content animated\">\r\n      <router-outlet>\r\n\r\n      </router-outlet>\r\n    </div>\r\n    <bw-index-footing></bw-index-footing>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index.component.html
// module id = ../../../../../ng-src/app/module/index-operation/index/index.component.html
// module chunks = main